module.exports = __webpack_public_path__ + "static/media/fitpiggy.c0bf20c4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/fitpiggy.webp
// module id = 233
// module chunks = 0